import { useState } from "react";
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../../common/Button";
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import CustomSelect from "../../../common/interactive/CustomSelect";
import NewPaymentForm from "../forms/NewPaymentForm";
import { updateNegotiationPayment } from "../../../../lib/fetchApi";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import PaymentsTablePractices from "./PaymentsTablePractices";
import { frontendOptions } from "../../../../lib/systemData";

import classes from './PaymentsTable.module.css'
import DisplayBoxRight from "../../../fragments/DisplayBoxRight";
import { formatCurrency } from "../../../../lib/script";
import GeneratePDFDownload from "../Shared/GeneratePDFDownload";
import BodySimpleModalV3 from "../../../common/modal/BodySimpleModalV3";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";

export default function PaymentsTable() {
    const dispatch = useDispatch()
    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)
    const negotiationEditDisabled = useUserTabEditPermissionDisabled('case_negotiation')
    const canEditNegotiation = !negotiationEditDisabled

    const [modalOpned, setModalOpned] = useState(false)
    function openModalHandler() {
        setModalOpned(true)
    }

    function closeModalHandler() {
        setModalOpned(false)
    }

    async function updatePayment(data) {
        const reqBody = {
            status: data.data.value
        }
        let update = await updateNegotiationPayment(userToken, activeCase.case.id, reqBody, data.identifier.id, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {       
            dispatch(caseActions.createOrUpdatePayment(update))     
        }  
        
    }

    function checkIfNegotiatonAmount(practices) {
        if (practices) {
            let options = []
            let negAmount = practices.some(item => item.lia_neg_amount)

            if (negAmount) {
                options.push('Liability')
            }

            let negAmountUM = practices.some(item => item.um_neg_amount)

            if (negAmountUM) {
                options.push('UM')
            }

            if (negAmount || negAmountUM) {
                return {
                    hasNeg: true,
                    negOptions: options
                }
            }
        }

        return {
            hasNeg: false,
            negOptions: []
        }
    }

    checkIfNegotiatonAmount(activeCase.practices)
    return <div style={{flex: 1}}>
        <div className={classes.payments_header}>
            <h3>Payments Table</h3>
            {canEditNegotiation && (
                <BodySimpleModalV3 message={['Negotiation amount is required for Liability or UM']} disabled={checkIfNegotiatonAmount(activeCase?.practices)?.hasNeg}>
                    <Button click={openModalHandler} btnStyle={'btn_small'} isDisabled={!checkIfNegotiatonAmount(activeCase?.practices)?.hasNeg}><i className="ti ti-square-plus"></i>add new</Button>
                </BodySimpleModalV3>
            )}
        </div>
        <table className='table-border-radius-8'>
            <thead>
                <tr>
                    <th>Date of receipt</th>
                    <th>Check #</th>
                    <th>Payee</th>
                    <th>Amount of Check</th>
                    <th>Source</th>
                    <th>Practices</th>
                    <th >Status</th>
                    {/* className="table-cell-fit" */}
                </tr>
            </thead>

            <tbody>
                {activeCase.case_negotiation && activeCase.case_negotiation.payments && activeCase.case_negotiation.payments.map(item => (
                    <tr key={item.id}>
                        <td>{item.receipt_date}</td>
                        <td>{item.check_number}</td>
                        <td>{item.payee}</td>
                        <td>
                            <DisplayBoxRight>${formatCurrency(item?.amount)}</DisplayBoxRight>
                            {/* <InputBoxCurrency textRight={true} currentValue={item.amount} identifier={{type: null, field: 'amount', type_id: null, folder: null}}/> */}
                        </td>
                        <td>{item.source}</td>
                        <td>
                            {item.practices && <PaymentsTablePractices item={item} />}                  
                        </td>
                        <td>
                            <CustomSelect action={updatePayment} optionsData={frontendOptions()?.checkStatusOptions} preSelectedValue={item.status} sameSizeAsContainer={true} reverseDrawer={true} identifier={{id: item.id, permissionType: 'case_negotiation'}}/>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>

        <div className="flex-container flex-container-end" style={{marginTop: 12}}>
            <GeneratePDFDownload url={'case-negotiation-payments-pdf'} boxStyle={'btn_grey'} fileName={'negotiation_payments.pdf'} disabled={!activeCase?.case_negotiation?.payments || activeCase?.case_negotiation?.payments?.length == 0}>
                <i className="ti ti-printer"></i> Statement
            </GeneratePDFDownload>
        </div>

        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'New Payment'}>
                        <NewPaymentForm closeModal={closeModalHandler} sourceLimitOpt={checkIfNegotiatonAmount(activeCase?.practices)?.negOptions}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}